import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { ProviderOutstandingsState, ProviderSummariesState } from './states';
import {
  ProviderOutstandingsActions,
  ProviderSummariesActions,
} from './actions';

// #region ProviderOutstanding
export const providerOutstandingsRecipe: Recipe<
  ProviderOutstandingsState,
  ProviderOutstandingsActions
> = (draft, action) => {
  switch (action.type) {
    case 'providerOutstandings/started':
      draft.pending = true;
      return;

    case 'providerOutstandings/finished':
      draft.pending = false;
      draft.providerOutstandings = action.providerOutstandings;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region ProviderSummary
export const providerSummariesRecipe: Recipe<
  ProviderSummariesState,
  ProviderSummariesActions
> = (draft, action) => {
  switch (action.type) {
    case 'providerSummaries/started':
      draft.pending = true;
      return;

    case 'providerSummaries/finished':
      draft.pending = false;
      draft.summaries = action.summaries;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
